// components/navbar/NavLogo.js
import React from "react";
import { NavLink } from "react-router-dom";

const NavLogo = () => {
  return (
    <NavLink to="/" className="navbar-logo">
      <span className="logo-text">Anime</span>
      <span className="logo-highlight">Nexus</span>
    </NavLink>
  );
};

export default NavLogo;